exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-overlay[data-v-3226e850]{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.5);display:flex;justify-content:center;align-items:center;z-index:9999}.loading-message[data-v-3226e850]{background-color:#fff;padding:20px 40px;border-radius:8px;text-align:center;box-shadow:0 4px 15px rgba(0,0,0,.3)}.fa-spinner[data-v-3226e850]{margin-top:10px;font-size:24px;color:#3498db}", ""]);

// exports
